import React, { Component } from "react";
import { connect } from "react-redux";
import classnames from "classnames";
import _ from "i18n";

import { createdDateFormat } from "Utils";
import { selectCurrentOrganization } from "Selectors";
import Slide from "../Dashboard/Slide";
import LegalFormsList from "./LegalFormsList";
import { ICONS, SvgIcon } from "../Common/Icons";

import styles from "./Item.local.scss";
import { getLabelsByLng } from "../../utils";

class Item extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isHovering: false
    };
  }
  handleMouseOver = () => {
    this.setState({ isHovering: true });
  };
  handleMouseOut = () => {
    this.setState({
      isHovering: false
    });
  };
  render() {
    let {
      lng,
      dashboard,
      preferences,
      backOffice,
      currentOrganization,
      withoutHeader,
      newTag,
      closeNewTag,
      filterStatus
    } = this.props;
    let allowUpdateDashboard =
      preferences && preferences.allowUpdateDashboard === "1";
    let legalforms = this.props.dashboard.legalForms.split(",");

    return (
      <div className={classnames("columns medium-3", styles.dashboard_item)}>
        <ul>
          <li
            className={styles.dashboard_card}
            style={
              ({ background: "#F8F9FA" },
              { width: withoutHeader ? "310px" : "320px" })
            }
            onMouseOver={this.handleMouseOver}
            onMouseOut={this.handleMouseOut}
          >
            {newTag &&
              newTag.notifications.map(notification => {
                return (
                  !this.state.isHovering &&
                  !closeNewTag &&
                  notification.dashboardId === dashboard.id && (
                    <div className={styles.newTag}>
                      <span>{_("new")}</span>
                    </div>
                  )
                );
              })}
            <div className={styles.dashboard_container}>
              {dashboard.slides[0] && (
                <div className={styles.item}>
                  {dashboard.slides[2] ? (
                    <Slide
                      key={dashboard.slides[2].id}
                      slide={dashboard.slides[2]}
                      isResponsive={false}
                    />
                  ) : (
                    <div className={styles.hidden_slide}>
                      <Slide
                        key={dashboard.slides[0].id}
                        slide={dashboard.slides[0]}
                        isResponsive={false}
                      />
                    </div>
                  )}
                  {dashboard.slides[1] ? (
                    <Slide
                      key={dashboard.slides[1].id}
                      slide={dashboard.slides[1]}
                      isResponsive={false}
                    />
                  ) : (
                    <div className={styles.hidden_slide}>
                      <Slide
                        key={dashboard.slides[0].id}
                        slide={dashboard.slides[0]}
                        isResponsive={false}
                      />
                    </div>
                  )}
                  <Slide
                    key={dashboard.slides[0].id}
                    slide={dashboard.slides[0]}
                    isResponsive={false}
                  />
                </div>
              )}
            </div>
            <div
              className={classnames(
                styles.informations_container,
                this.state.isHovering && styles.information_icon
              )}
              style={{ background: "#FFFFFF" }}
            >
              <div>
                <div className={styles.information_bloc}>
                  <h2 className={styles.title}>
                    {getLabelsByLng(dashboard.labels, lng).length > 20 &&
                    !this.state.isHovering
                      ? getLabelsByLng(dashboard.labels, lng).substring(0, 15) +
                        " ..."
                      : getLabelsByLng(dashboard.labels, lng)}
                  </h2>
                  <div className={styles.date}>
                    <span>
                      {_("createdAt")}{" "}
                      {createdDateFormat(dashboard.createdAt, lng)} <br />
                    </span>
                    <span>
                      {dashboard.organization !== "STANDARD" &&
                      dashboard.originOrganization
                        ? _("by") + " " + dashboard.originOrganization
                        : dashboard.organization === "STANDARD"
                          ? _("standard")
                          : _("by") + " " + dashboard.organization}
                    </span>
                  </div>
                </div>
                <div className={styles.flags}>
                  {dashboard.labels.fr.length > 0 && (
                    <img src="/img/icons/fr_flag.svg" alt="" />
                  )}
                  {dashboard.labels.nl.length > 0 && (
                    <img src="/img/icons/nl_flag.svg" alt="" />
                  )}
                  {dashboard.labels.en.length > 0 && (
                    <img src="/img/icons/en_flag.svg" alt="" />
                  )}
                </div>
                <div className={styles.status}>
                  {dashboard.isPublic === true ? (
                    <div className={styles.tags}>
                      {dashboard.status != "STANDARD" ? (
                        <div>
                          <SvgIcon
                            icon={ICONS.Share}
                            className={styles.statusIcon}
                          />
                          <span>{_("share")}</span>
                        </div>
                      ) : (
                        <div>
                          <SvgIcon
                            icon={ICONS.Standard}
                            className={styles.statusIcon}
                          />
                          <span>{_("standard")}</span>
                        </div>
                      )}
                    </div>
                  ) : (
                    <div className={styles.tags}>
                      <SvgIcon
                        icon={ICONS.Lock}
                        className={styles.statusIcon}
                      />
                      <span>{_("private")}</span>
                    </div>
                  )}
                  {dashboard.status != "STANDARD" && (
                    <div style={{ display: "inline" }}>
                      {dashboard.isOriginal === true ? (
                        <div className={styles.tags}>
                          <SvgIcon
                            icon={ICONS.Original}
                            className={styles.statusIcon}
                          />
                          <span>{_("original")}</span>
                        </div>
                      ) : (
                        <div className={styles.tags}>
                          <SvgIcon
                            icon={ICONS.Duplicated}
                            className={styles.statusIcon}
                          />
                          <span>{_("duplicated")}</span>
                        </div>
                      )}
                    </div>
                  )}
                  <span className={classnames(styles.tags, styles.slidesCount)}>
                    {dashboard.nbSlides}
                    {""} {_("slide")}
                  </span>

                  <div
                    className={styles.flex_container}
                    style={{ display: !this.state.isHovering && "none" }}
                  >
                    <LegalFormsList legalForms={legalforms} />
                  </div>

                  <div
                    className={styles.more_information}
                    style={{ display: !this.state.isHovering && "none" }}
                  >
                    <div className={styles.actions_container}>
                      {dashboard.status === "CREATED" || backOffice ? (
                        <div>
                          {this.props.selectedFilterValue !== "SHARED" &&
                          currentOrganization.uen ===
                            dashboard.organizationUen ? (
                            <div>
                              <div
                                className={classnames(
                                  "d-flex align-items-center justify-content-center",
                                  styles.actions,
                                  getLabelsByLng(dashboard.labels, lng).length >
                                  50
                                    ? styles.action_position
                                    : styles.action_position_hover
                                )}
                              >
                                <div
                                  onClick={() =>
                                    this.props.displayDashboardSlides({
                                      dashboard
                                    })
                                  }
                                >
                                  <SvgIcon
                                    icon={ICONS.LOOP_ICON}
                                    className={""}
                                  />
                                </div>
                                {allowUpdateDashboard && (
                                  <div
                                    onClick={() =>
                                      this.props.handleDisplayUpdateDashboard({
                                        dashboard
                                      })
                                    }
                                  >
                                    <SvgIcon
                                      icon={ICONS.EDIT_ICON}
                                      className={""}
                                    />
                                  </div>
                                )}
                                <div
                                  onClick={() =>
                                    this.props.duplicateDashboard(dashboard.id)
                                  }
                                >
                                  <SvgIcon
                                    icon={ICONS.DUPLICATE_ICON}
                                    className={""}
                                  />
                                </div>
                                {!dashboard.isPublic ? (
                                  <div
                                    onClick={() =>
                                      this.props.shareDashboard(
                                        dashboard.id,
                                        dashboard.isEditable
                                      )
                                    }
                                  >
                                    <SvgIcon
                                      icon={ICONS.Share}
                                      className={""}
                                    />
                                  </div>
                                ) : (
                                  <div
                                    onClick={() =>
                                      this.props.handleSetDashboardPrivacy(
                                        dashboard.id
                                      )
                                    }
                                  >
                                    <SvgIcon
                                      icon={ICONS.Unshared}
                                      className={""}
                                    />
                                  </div>
                                )}
                              </div>
                              <div
                                className={classnames(
                                  "d-flex align-items-center justify-content-center",
                                  styles.actions
                                )}
                              >
                                <div
                                  onClick={() =>
                                    this.props.deleteDashboard(dashboard.id)
                                  }
                                  className={styles.delete_action}
                                >
                                  <SvgIcon icon={ICONS.DELETE_ICON} />
                                </div>
                              </div>
                            </div>
                          ) : // <div className={`row ${styles.actions} `}>
                          !backOffice ? (
                            <div
                              className={classnames(
                                styles.actions,
                                getLabelsByLng(dashboard.labels, lng).length >
                                50
                                  ? styles.action_position_created
                                  : styles.action_position_created_hover
                              )}
                            >
                              {!(
                                filterStatus === "Templates" ||
                                filterStatus === "MyTemplates"
                              ) ? (
                                <div
                                  onClick={() =>
                                    dashboard.isEditable
                                      ? this.props.updateStateDashboard(
                                          dashboard.id
                                        )
                                      : this.props.handleUseSharedDashboard(
                                          dashboard.id
                                        )
                                  }
                                >
                                  <SvgIcon
                                    icon={ICONS.SIMPLE_PLUS_ICON}
                                    className={""}
                                  />
                                </div>
                              ) : (
                                <div
                                  onClick={() =>
                                    this.props.displayDashboardSlides({
                                      dashboard
                                    })
                                  }
                                >
                                  <SvgIcon
                                    icon={ICONS.LOOP_ICON}
                                    className={""}
                                  />
                                </div>
                              )}
                              {/*</div>*/}
                            </div>
                          ) : (
                            <div
                              className={classnames(
                                "d-flex align-items-center justify-content-center",
                                styles.actions,
                                getLabelsByLng(dashboard.labels, lng).length >
                                50
                                  ? styles.action_position
                                  : styles.action_position_hover
                              )}
                            >
                              <div
                                onClick={() =>
                                  this.props.displayDashboardSlides({
                                    dashboard
                                  })
                                }
                              >
                                <SvgIcon
                                  icon={ICONS.LOOP_ICON}
                                  className={""}
                                />
                              </div>
                              {allowUpdateDashboard && (
                                <div
                                  onClick={() =>
                                    this.props.handleDisplayUpdateDashboard({
                                      dashboard
                                    })
                                  }
                                >
                                  <SvgIcon
                                    icon={ICONS.EDIT_ICON}
                                    className={""}
                                  />
                                </div>
                              )}
                              <div
                                onClick={() =>
                                  this.props.duplicateDashboard(dashboard.id)
                                }
                              >
                                <SvgIcon
                                  icon={ICONS.DUPLICATE_ICON}
                                  className={""}
                                />
                              </div>
                              <div
                                onClick={() =>
                                  this.props.deleteDashboard(dashboard.id)
                                }
                                className={styles.delete_action}
                              >
                                <SvgIcon icon={ICONS.DELETE_ICON} />
                              </div>
                            </div>
                          )}
                        </div>
                      ) : (
                        <div className={`row ${styles.actions} `}>
                          <div
                            className={classnames(
                              styles.actions,
                              getLabelsByLng(dashboard.labels, lng).length > 50
                                ? styles.action_position_created
                                : styles.action_position_created_hover
                            )}
                            onClick={() =>
                              this.props.duplicateDashboard(dashboard.id)
                            }
                          >
                            <SvgIcon
                              icon={ICONS.DUPLICATE_ICON}
                              className={""}
                            />
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </li>
        </ul>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  lng: state.params.lng,
  backOffice: state.params.backOffice,
  preferences: state.auth.preferences,
  currentOrganization: selectCurrentOrganization(state),
  withoutHeader: state.auth.withoutHeader,
  filterStatus: state.dashboardList.filterStatus
});

export default connect(mapStateToProps)(Item);



// WEBPACK FOOTER //
// ./src/components/DashboardList/Item.js